import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

function isValidBase64Image(base64) {
  if (!base64 || typeof base64 !== 'string') return false;
  if (base64.startsWith('data:image')) return true;
  const base64clean = base64.replace(/\s/g, '');
  const base64regex = /^[A-Za-z0-9+/=]+$/;
  return base64regex.test(base64clean);
}

function normalizeBase64Image(base64, tipo = 'jpeg') {
  if (!base64 || !isValidBase64Image(base64)) return null;
  if (base64.startsWith('data:image')) return base64;
  const base64clean = base64.replace(/\s/g, '');
  return `data:image/${tipo};base64,${base64clean}`;
}

async function cortarImagemEmCirculo(src, tamanho = 45) {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.src = src;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = tamanho;
      canvas.height = tamanho;
      const ctx = canvas.getContext('2d');
      ctx.beginPath();
      ctx.arc(tamanho / 2, tamanho / 2, tamanho / 2, 0, Math.PI * 2);
      ctx.closePath();
      ctx.clip();
      ctx.drawImage(img, 0, 0, tamanho, tamanho);
      resolve(canvas.toDataURL());
    };
    img.onerror = () => resolve(src);
  });
}

async function RefeicaoPDF(funcionarios) {
  // 1. Filtra marmitex e ordena por: Loja -> Turno -> Hora de Solicitação
  const funcionariosEtiqueta = funcionarios
    .filter((f) => f.marmitex === 1)
    .sort((a, b) => {
      const lojaA = Number(a.loja) || 0;
      const lojaB = Number(b.loja) || 0;
      if (lojaA !== lojaB) return lojaA - lojaB;

      const turnoA = Number(a.turno) || 0;
      const turnoB = Number(b.turno) || 0;
      if (turnoA !== turnoB) return turnoA - turnoB;

      const horaA = a.horasol || '';
      const horaB = b.horasol || '';
      return horaA.localeCompare(horaB);
    });

  const criarEtiqueta = async (cliente) => {
    const imagemDefault = 'https://upload.wikimedia.org/wikipedia/commons/0/03/Sem_imagem.jpg';
    const base64Normalizado = normalizeBase64Image(cliente.foto);
    const imagemParaUsar = base64Normalizado || imagemDefault;
    const imagemCircular = await cortarImagemEmCirculo(imagemParaUsar, 45);

    const lojaFormatada = String(cliente.loja || '').padStart(2, '0');

    const colunaEsquerda = {
      stack: [
        {
          text: `Loja ${lojaFormatada}`,
          fontSize: 8.5,
          bold: true,
          alignment: 'center',
          margin: [0, 0, 0, 2],
        },
        {
          image: imagemCircular,
          width: 42,
          height: 42,
          alignment: 'center',
          margin: [0, 0, 0, 2],
        },
        {
          text: `Chapa: ${cliente.chapa || ''}`,
          fontSize: 7.5,
          bold: true,
          alignment: 'center',
          margin: [0, 0, 0, 1],
        },
        {
          text: `Solicitado:\n${cliente.horasol || '--:--'}`,
          fontSize: 7,
          alignment: 'center',
        },
      ],
      width: 65,
      margin: [0, 0, 4, 0],
    };

    const stackDetalhes = [
      { text: cliente.nome, fontSize: 11.5, bold: true, margin: [0, 0, 0, 2] },
      {
        text: 'Cardápio: ' + cliente.menu,
        bold: true,
        fontSize: 8.5,
        margin: [0, 0, 0, 2],
      },
    ];

    if (cliente.observacao && cliente.observacao.trim() !== '') {
      stackDetalhes.push({
        text: 'Obs: ' + cliente.observacao,
        fontSize: 8,
        italics: true,
        margin: [0, 0, 0, 2],
      });
    }

    // Validação correta: Apenas valor 2 (ou '2') é tratado como Segundo Turno
    const isSegundoTurno = Number(cliente.turno) === 2 || cliente.turno === '2';
    const textoTurno = isSegundoTurno ? 'SEGUNDO TURNO' : 'PRIMEIRO TURNO';

    stackDetalhes.push({
      table: {
        widths: ['*'],
        body: [
          [
            {
              text: textoTurno,
              fillColor: '#dc3545',
              color: '#ffffff',
              bold: true,
              fontSize: 8,
              alignment: 'center',
              margin: [0, 2, 0, 2],
            },
          ],
        ],
      },
      layout: 'noBorders',
      margin: [0, 2, 0, 0],
    });

    return {
      unbreakable: true,
      table: {
        widths: ['auto', '*'],
        body: [
          [
            colunaEsquerda,
            {
              stack: stackDetalhes,
            },
          ],
        ],
      },
      layout: {
        hLineWidth: () => 0.8,
        vLineWidth: () => 0.8,
        hLineColor: () => '#000000',
        vLineColor: () => '#000000',
        paddingTop: () => 3,
        paddingBottom: () => 3,
        paddingLeft: () => 4,
        paddingRight: () => 4,
        hLineStyle: () => ({ dash: { length: 3, space: 3 } }),
        vLineStyle: () => ({ dash: { length: 3, space: 3 } }),
      },
    };
  };

  const conteudoPDF = [];
  const etiquetasPorLinha = 2;

  for (let i = 0; i < funcionariosEtiqueta.length; i += etiquetasPorLinha) {
    const etq1 = await criarEtiqueta(funcionariosEtiqueta[i]);
    const etq2 = funcionariosEtiqueta[i + 1] ? await criarEtiqueta(funcionariosEtiqueta[i + 1]) : null;

    const linhaTabela = {
      margin: [0, 0, 0, 4],
      unbreakable: true,
      table: {
        widths: ['*', '*'],
        dontBreakRows: true,
        body: [
          [
            etq1,
            etq2 || { text: '', border: [false, false, false, false] },
          ],
        ],
      },
      layout: 'noBorders',
    };

    conteudoPDF.push(linhaTabela);
  }

  const docDefinition = {
    pageSize: 'A4',
    pageMargins: [12, 10, 12, 12],
    content: conteudoPDF,
    footer: function (currentPage, pageCount) {
      return {
        text: `${currentPage} / ${pageCount}`,
        alignment: 'right',
        fontSize: 8,
        margin: [0, 0, 12, 0],
      };
    },
  };

  try {
    pdfMake.createPdf(docDefinition).download('marmitex.pdf');
  } catch (error) {
    console.error('Erro ao gerar PDF:', error);
  }
}

export default RefeicaoPDF;